import { Icon, IconName } from "@blueprintjs/core";

import { BoxProps, Flex } from "@/components/layout/flexbox";

interface MeetingIconProps extends BoxProps {
  size?: number;
  backgroundColor: string;
  color?: string;
  icon?: IconName;
  style?: React.CSSProperties;
}

export function MeetingIcon({
  size = 50,
  backgroundColor,
  color = "#FFF",
  icon = "calendar",
  style,
  ...props
}: MeetingIconProps) {
  return (
    <Flex
      width={size}
      height={size}
      style={{
        borderRadius: size,
        ...style,
      }}
      backgroundColor={backgroundColor}
      alignItems="center"
      justifyContent="center"
      {...props}
    >
      <Icon icon={icon} size={size * (2 / 5)} color={color} />
    </Flex>
  );
}
